import { getUserRole } from "~/shared/auth-utils";
import { useLocation, useParams } from 'react-router-dom';

export default function useNavbar() {
    const location = useLocation();
    const { familyId } = useParams();

    const items = getUserRole() === "FAMILY" ? [
        { text: "Home", link: "/home" },
        { text: "View Programs", link: "https://nextgenerationfocus.org/programs" },
        { text: "Tutoring Payments", link: "/tutor" },
        { text: "Contact Us", link: "/contact" }
    ] : [
        { text: "Account Info", link: `/family/${familyId}` },
        { text: "Back to Search", link: "/admin/manage-families" }
    ];

    items.forEach(item => item.disabled = location.pathname === item.link);
    return [{ text: getUserRole() === "FAMILY" ? "My Account" : "Account", dropdown: true, items }];
}